import { render, staticRenderFns } from "./UntrackableBrandOverview.vue?vue&type=template&id=1d0bc814&scoped=true"
import script from "./UntrackableBrandOverview.vue?vue&type=script&lang=js"
export * from "./UntrackableBrandOverview.vue?vue&type=script&lang=js"
import style0 from "./UntrackableBrandOverview.vue?vue&type=style&index=0&id=1d0bc814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0bc814",
  null
  
)

export default component.exports